export enum SeedingTypeEnum {
  HATCHERY = 'hatchery',
}
